import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../editor/toolbar/Button";
import {
  HeadCountsByVessel,
} from "../../common/JobOrder";
import { exportSingleSheetExcel } from "../../util/excelDocument";

const VesselHeadCounts = (props: {
  vesselHeadCounts: HeadCountsByVessel[];
  onClose?: (bol: boolean) => void;
}) => {
  const closeDialog = () => {
    if (!!props.onClose) {
      props.onClose(false);
    }
  };

  const exportFile = async () => {
    await exportSingleSheetExcel(
      {
        data: props.vesselHeadCounts,
        documentName: "VesselHeadCounts",
        sheetName: "HeadCounts",
      },
      [
        { label: "Vessel", name: "vessel", width: 25 },
        { label: "Count", name: "headCount", width: 20 },
        { label: "ROS/FOS", name: "rosFos", width: 20 },
      ]
    );
  };

  return (
    <div>
      <div className="flex align-items-center justify-content-btwn mb-1">
        <h1 className="mr-2">Head Count By Vessel</h1>
        <div className="flex g-1 vessel-headcount-actions">
          <Button onClick={exportFile}>
            EXPORT TO EXCEL
          </Button>
          {!!props?.onClose && (
            <Button onClick={closeDialog}>
              <CloseIcon />
            </Button>
          )}
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Vessel</TableCell>
            <TableCell>Count</TableCell>
            <TableCell>ROS/FOS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.vesselHeadCounts.map((row) => {
            return (
              <TableRow key={`${row.vesselId}`}>
                <TableCell>{row.vessel}</TableCell>
                <TableCell>{row.headCount}</TableCell>
                <TableCell>{row.rosFos ?? ''}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default VesselHeadCounts;
